export default __webpack_public_path__ + "static/media/06exigo.3bf75bc1.jpg";